import apiClient from "./axiosConfig";

export const getImeiList = async (search = "", page = 1, pageSize = 10, supplierId = "") => {
  try {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (page) params.append("page", page);
    if (pageSize) params.append("page_size", pageSize);
    if (supplierId) params.append("supplier_id", supplierId);

    const queryString = params.toString();
    const url = queryString
      ? `/imei/list/?${queryString}`
      : "/imei/list/";

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching IMEI list:", error);
    throw error;
  }
};

export const getImeiRecordById = async (recordId) => {
  try {
    const response = await apiClient.get(`/imei/detail/${recordId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching IMEI record ${recordId}:`, error);
    throw error;
  }
};

export const createImeiRecord = async (recordData) => {
  try {
    const requestBody = {
      supplier: parseInt(recordData.supplier_id) || 0,
      notes: recordData.notes || "",
      total_numbers: parseInt(recordData.numbers) || 0
    };
    const response = await apiClient.post("/imei/create/", requestBody);
    return response.data;
  } catch (error) {
    console.error("Error creating IMEI record:", error);
    throw error;
  }
};

export const updateImeiRecord = async (recordId, recordData) => {
  try {
    const response = await apiClient.put(`/imei/${recordId}`, recordData);
    return response.data;
  } catch (error) {
    console.error(`Error updating IMEI record ${recordId}:`, error);
    throw error;
  }
};

export const deleteImeiRecord = async (recordId) => {
  try {
    const response = await apiClient.delete(`/imei/delete/${recordId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting IMEI record ${recordId}:`, error);
    throw error;
  }
};

export const addImeiToRecord = async (recordId, imeiData) => {
  try {
    const response = await apiClient.post(`/imei/add-imei/${recordId}/`, imeiData);
    return response.data;
  } catch (error) {
    console.error(`Error adding IMEI to record ${recordId}:`, error);
    throw error;
  }
};

export const deleteImeiFromRecord = async (imeiId) => {
  try {
    const response = await apiClient.delete(`/imei/delete-imei/${imeiId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting IMEI ${imeiId}:`, error);
    throw error;
  }
};

export const importBulkImei = async (recordId, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await apiClient.post(`/imei/import/${recordId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error importing bulk IMEI to record ${recordId}:`, error);
    throw error;
  }
};

export const exportImeiRecord = async (recordId) => {
  try {
    const response = await apiClient.get(`/imei/export/${recordId}/`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting IMEI record ${recordId}:`, error);
    throw error;
  }
};
